import { Grid } from '@mui/material';

import { AssistantSuggestedQuestionChip } from './suggested-questions/AssistantSuggestedQuestionChip';

const SUGGESTED_QUESTIONS = [
  <>
    What should I <strong>ask in my SEND governor visit</strong>
  </>,
  <>
    How can my board <strong>demonstrate effectiveness</strong>
  </>,
  <>
    Why does GovernorHub store <strong>diversity data</strong>
  </>,
  <>
    Is poor attendance a valid reason <strong>for exclusion</strong>
  </>,
];

interface Props {
  loading: boolean;
  onQuestionClick: (question: string) => void;
}

export const AssistantSuggestedQuestions = ({
  loading,
  onQuestionClick,
}: Props) => {
  return (
    <Grid container spacing={2}>
      {SUGGESTED_QUESTIONS.map((question, index) => (
        <Grid key={index}>
          <AssistantSuggestedQuestionChip
            loading={loading}
            onClick={onQuestionClick}
          >
            {question}?
          </AssistantSuggestedQuestionChip>
        </Grid>
      ))}
    </Grid>
  );
};
